<template>
	<div class="newBarA">
		<!-- 区域 -->
		<div class="newBarV" @mouseleave="enterIndex = -1">
			<!-- 包裹 -->
			<div v-for="(items,index) in navList" :key="index" @mouseenter="mouseOverOne(index)"
				@click="navtoPage(index,items)"
				:class="[enterIndex == index || selectIndex == index  ? 'activeSon':'','newBarB_p']">
				<el-image style="width: 24px;height: 24px;opacity: 0.8;" :src="imgUrlList[index]" alt="" />
				<p>{{items.label}}
				</p>
			</div>
			<div class="newImg" v-if="totalNum>7" style="flex: 0.6;">
				<el-popover placement="bottom" trigger="hover">
					<div class="newImg_view">
						<p v-for="(item,index) in otherList" :key="index" @click="navtoPage(index,item)">{{item.label}}
						</p>
					</div>
					<img slot="reference" :src="giveMeMore" alt="">
				</el-popover>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getNavList
	} from '../api/moudles/user.js'
	export default {
		data() {
			return {
				imgUrlList: [require('../assets/img/webIndex/1.png'),
					require('../assets/img/webIndex/2.png'),
					require('../assets/img/webIndex/3.png'),
					require('../assets/img/webIndex/4.png'),
					require('../assets/img/webIndex/5.png'),
					require('../assets/img/webIndex/6.png'),
					require('../assets/img/webIndex/7.png')
				],
				totalNum: 0,
				enterIndex: -1,
				selectIndex: -1,
				navList: [],
				otherList: [],
				giveMeMore: require('../assets/img/school/more.png')
			}
		},
		props: {},
		watch: {

		},
		created() {
			this.getNavList()
		},
		methods: {
			// 导航栏
			async getNavList() {
				this.topNav = false
				await getNavList({
					data: {
						position: 1
					},
					success: (res) => {
						// console.log('导航栏',res)
						this.totalNum = res.data.length
						if (res.data.length > 7) {
							this.navList = res.data.slice(0, 7)
							this.otherList = res.data.slice(7, res.data.length)
						} else {
							this.navList = res.data
						}
					}
				})
			},
			// 一级栏目悬浮
			mouseOverOne(index) {
				this.enterIndex = index
			},
			navtoPage(index, items) {
				console.log('index', index)
				console.log('items', items)

				if (items.model == 1) {

					this.$router.push({
						path: '/dynamic/list',
						query: {
							key: items.key,
							label: items.label
						}
					})

				} else if (items.model == 0) {

					if (items.label == '首页') {
						this.$router.push('/webIndex')
					} else {
						this.$router.push('/announce/list')
					}

				} else if (items.model == 4) {

					window.open(items.link)
				} else if (items.model == 7) {

					this.$router.push({
						path: '/admissionNotice',
						query: {
							key: items.key,
							label: items.label
						}
					})
				}
			}
		}
	}
</script>

<style scoped>
	.newBarA {
		width: 1050px;
		/* width: 100%; */
	}

	.newBarV {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-right: 20px;
	}

	.newImg {
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.newImg_view>p {
		font-family: PingFangSC-Semibold;
		font-size: 16px;
		letter-spacing: 0;
		font-weight: 500;
		height: 40px;
		line-height: 40px;
		text-align: center;
		box-sizing: border-box;
	}

	.newImg_view>p:hover {
		background-color: #f5f5f5;
		cursor: pointer;
	}

	.newBarB_p {
		display: flex;
		align-items: center;
		font-family: PingFangSC-Semibold;
		font-size: 16px;
		color: black;
		/* flex: 1; */
		color: #fff;
		letter-spacing: 0;
		font-weight: 500;
		height: 60px;
		line-height: 60px;
		text-align: center;
		box-sizing: border-box;
	}

	.newBarB_p:hover {
		transform: scale(1.2);
	}

	.newBarB_p p {
		margin-left: 5px;
	}

	.activeSon p {
		display: inline-block;
		/* border-bottom: 4px solid #0182FD; */
		cursor: pointer;
	}

	/* 浮动 */
	.newBarF {
		position: absolute;
		background-color: #fff;
		z-index: 999;
		box-shadow: 0px 0px 16px 0px rgb(0 0 0 / 10%);
		padding: 1.33rem 2.67rem;
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-gap: 1rem;
		line-height: 1.58rem;
		cursor: pointer;
		box-sizing: border-box;
	}

	/* 搜索 */
	.headerSearch {
		width: 195px;
		height: 40px;
		background: #FFFFFF;
		box-shadow: 0px 0px 8px 0px rgba(24, 56, 90, 0.2700);
		display: flex;
		cursor: pointer;
	}

	.headerSearch input {
		width: 192px;
		border-radius: 4px 0 0 4px;
		padding-left: 16px;
	}
</style>
